import React, { PureComponent } from 'react';

import './book.scss';
import Classify from './classify';
import Patient from './patient';
import Inspect from './inspect'

class Book extends PureComponent {
  constructor() {
    super()
    this.state = {
      inspectRef: React.createRef(),
      patientRef: React.createRef(),
    }
  }

  getDatas = (data) => {
    this.setState({
      tableData: data  //把表格传来的值给表单
    })
  }

  getSourceType = (source) => {
    this.setState({
      sourceType: source
    })
  }

  getAddSubmit = (type) => {
    this.setState({
      addType: type
    })
  }

  getDataTime = (dateString) => {
    this.setState({
      dataTime: dateString
    })
  }

  getBirthdayTime = (dateString) => {
    this.setState({
      birthdayTime: dateString
    })
  }

  getInspectItem = (item) => {
    this.setState({
      itemName: item.props.children,
      itemCode: item.props.value
    })
  }

  getExamDoctor = (option) => {
    this.setState({
      examDoctorCode: option.props.value,
      examDoctorName: option.props.children,
    })
  }

  getDoctor = (option) => {
    this.setState({
      doctorCode: option.props.value,
      doctorName: option.props.children,
    })
  }

  getExamHospitalDept = (option) => {
    this.setState({
      examDeptCode: option.props.value,
      examDeptName: option.props.children,
    })
  }
  getHospitalDept = (option) => {
    this.setState({
      deptCode: option.props.value,
      deptName: option.props.children,
    })
  }

  // 提取InspectData组件的Form数据
  GetInspectData = () => {
    return this.state.inspectRef.current.getFieldsValue()
  }
  // 提取PatientData组件的Form数据
  GetPatientData = () => {
    return this.state.patientRef.current.validateFields()
  }

  onRef = (ref) => {
    this.Classify = ref;
  }

  render() {
    const { tableData, inspectRef, itemName, itemCode, doctorCode, doctorName, examDeptCode, examDeptName, deptCode, deptName, examDoctorCode, examDoctorName, birthdayTime, patientRef, dataTime, addType, sourceType } = this.state
    return (
      <div>
        <div className="bookWrap">
          {/* 检查信息组件 */}
          <Patient
            getInspectData={this.GetInspectData}
            clickApptQuery={() => { this.Classify && this.Classify.changeApptQuery() }} // 待预约
            clickAppoQuery={() => { this.Classify && this.Classify.handleAppoQuery() }} // 预约
            clickRegQuery={() => { this.Classify && this.Classify.handleRegQuery() }} // 登记
            ref={patientRef}
            tableData={tableData}
            dataTime={dataTime}
            itemName={itemName}
            itemCode={itemCode}
            doctorName={doctorName}
            doctorCode={doctorCode}
            examDeptName={examDeptName}
            examDeptCode={examDeptCode}
            deptName={deptName}
            deptCode={deptCode}
            examDoctorName={examDoctorName}
            examDoctorCode={examDoctorCode}
            setBirthdayTime={this.getBirthdayTime}
            setAddSubmit={this.getAddSubmit}
          />
          {/* 病人信息组件 */}
          <Inspect
            getPatientData={this.GetPatientData}
            clickApptQuery={() => { this.Classify && this.Classify.changeApptQuery() }} // 待预约
            clickAppoQuery={() => { this.Classify && this.Classify.handleAppoQuery() }} // 预约
            clickRegQuery={() => { this.Classify && this.Classify.handleRegQuery() }} // 登记
            ref={inspectRef}
            tableData={tableData}
            addType={addType}
            birthdayTime={birthdayTime}
            setDataTime={this.getDataTime}  // 检查时间
            setSourceType={this.getSourceType}  // 来源
            setInspectItem={this.getInspectItem}  // 检查项目
            setExamDoctor={this.getExamDoctor}  // 检查医生
            setDoctor={this.getDoctor} // 申请医生
            setExamHospitalDept={this.getExamHospitalDept} //检查科室
            setHospitalDept={this.getHospitalDept} // 申请科室
          />
          <Classify data={this.getDatas} sourceType={sourceType} setAddSubmit={this.getAddSubmit} onRef={this.onRef} />{/* 表格组件 */}
        </div>
      </div>
    )
  }
}
export default Book;
